<template>
  <div class="alert-box-wrap" v-show="paramObj.isShow">
    <div class="alert-box">
      <div class="top-cnt">
        <div class="title">{{paramObj.title||'提示'}}</div>
        <div class="content">{{paramObj.content}}</div>
      </div>
      <div class="bottom-btn clear">
        <div class="left fl" @click="paramObj.isShow=false">取消</div>
        <div class="right fl" @click="handleCert">确定</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    paramObj: Object
  },
  methods: {
    handleCert() {
      this.$emit('handle-cert')
    }
  }
}
</script>
<style lang="less" scoped>
.alert-box-wrap {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 99;
  background: rgba(0, 0, 0, 0.3);
  .alert-box {
    width: 5.6rem;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 0.08rem;
    overflow: hidden;

    box-sizing: border-box;
    .top-cnt {
      text-align: center;
      border-bottom: 0.01rem solid rgb(210, 211, 213);
      padding: 0.52rem 0.32rem 0.32rem;
      .title {
        font-size: 0.36rem;
        color: #000;
        margin-bottom: 0.33rem;
      }
      .content {
        font-size: 0.3rem;
        color: rgb(153, 153, 153);
      }
    }
    .bottom-btn {
      height: 0.99rem;
      line-height: 0.99rem;
      text-align: center;
      .left,
      .right {
        width: 50%;
        box-sizing: border-box;
        font-size: 0.36rem;
        color: #000;
      }
      .left {
        border-right: 0.01rem solid rgb(210, 211, 213);
      }
      .right {
        color: rgb(0, 194, 0);
      }
    }
  }
}
</style>